import { render, staticRenderFns } from "./ShapeOverlay.vue?vue&type=template&id=d1365efa"
import script from "./ShapeOverlay.vue?vue&type=script&lang=js"
export * from "./ShapeOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports